import { Row, Col, Button } from "react-bootstrap";
import ImageBackground from '../ImageBackground.jsx'
import Description from "../Description.jsx";

const TroisBoutonsAccueil = ({
    showAlreadyVoted,
    asAlreadyVoted,
    interaction,
    isImageBlur,
    verifyAsAlreadVoted,
    demanderEnregistrement,
    textBTNParticiper,
    changerAfficherEtapeCollecteParticipationVoix,
    changerAfficherEtapeCollecteParticipationTexte,
    dispositionBoutons = 'horizontal',
    showDescription = false
}) => {
    return (
        <div className="accueil">
            {showAlreadyVoted &&
                <>
                    <div className={asAlreadyVoted}  >Désolé, <br />
                        Vous êtes limité à une <br />
                        participation pour cette <br />
                        événement
                    </div>
                </>
            }
            <Row className="home-background text-center">
                <Col>
                    <ImageBackground interaction={interaction} isImageBlur={isImageBlur} />
                </Col>
            </Row>
            {showDescription &&
                <Row className="custom-instructions">
                    <Col>
                        <Description interaction={interaction} />
                    </Col>
                </Row>
            }
            <div className="bouton-bfm">
                <Row className="custom-commandes">
                    <Col>
                        <Button onClick={e => verifyAsAlreadVoted(demanderEnregistrement)}>{textBTNParticiper}</Button>
                    </Col>
                </Row>
                <Row className={`custom-collecte-participation ${dispositionBoutons === 'vertical' ? 'flex-column' : ''}`}>
                    <Col className="col-btn-voix">
                        <Button onClick={e => verifyAsAlreadVoted(changerAfficherEtapeCollecteParticipationVoix)} className="custom-btn-voix"><span>Par la voix</span></Button>
                    </Col>
                    <Col>
                        <Button onClick={e => verifyAsAlreadVoted(changerAfficherEtapeCollecteParticipationTexte)} className="custom-btn-ecrit"><span>Par écrit</span></Button>
                    </Col>
                </Row>
            </div>
        </div>
    )
};
export default TroisBoutonsAccueil;